// startup
// Load entry module and return exports
__webpack_require__("./js/animations.js");
__webpack_require__("./js/entry.js");
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./js/helpers.js");
var __webpack_exports__ = __webpack_require__("./js/main.js");
